import React, { createContext, useContext, useEffect, useState } from 'react'
import { auth } from '../utils/firebase'
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  confirmPasswordReset,
  signInWithEmailLink,
  isSignInWithEmailLink,
  sendSignInLinkToEmail 
} from 'firebase/auth'

const AuthContext = createContext({
  currentUser: null,
  signInWithGoogle: () => Promise,
  login: () => Promise,  
  sendSignInLink: () => Promise,
  signInLink: () => Promise,  
  register: () => Promise,
  logout: () => Promise,
  forgotPassword: () => Promise,
  resetPassword: () => Promise,
})

export const useAuth = () => useContext(AuthContext)

export default function AuthContextProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      setCurrentUser(user ? user : null)
      console.log(user);
    })
    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    console.log('The user is', currentUser)
  }, [currentUser])

  // useEffect(() => {
  //   const GetUser = currentUser.uid;
  // }, [currentUser])

  // //----------
  // useEffect(() => {
  //   let email = window.localStorage.getItem('emailForSignIn');

  //   if (isSignInWithEmailLink(window.location.href)) {
  //     if (!email) {
  //       email = window.prompt('Please provide your email for confirmation');
  //     }
  //     signInWithEmailLink(email, window.location.href)
  //       .then(function(result) {
  //         window.localStorage.removeItem('emailForSignIn');
  //       })
  //       .catch(function(error) {
  //         alert(error);
  //       });
  //   }
  //   onAuthStateChanged(setCurrentUser);
  // }, []);

  // //----------

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password)
  }


  function register(email, password) {
    return createUserWithEmailAndPassword(auth, email, password)
  }
  function signInLink(email, code) {
    return signInWithEmailLink(auth, email, code)
  }
  function sendSignInLink(email, actionCodeSettings) {
    return sendSignInLinkToEmail(auth, email, actionCodeSettings)
  }

  function forgotPassword(email) {
    return sendPasswordResetEmail(auth, email, {
      url: `http://localhost:3000/login`,
    })
  }

  function resetPassword(oobCode, newPassword) {
    return confirmPasswordReset(auth, oobCode, newPassword)
  }

  function logout() {
    return signOut(auth)
  }

  function signInWithGoogle() {
    const provider = new GoogleAuthProvider()
    return signInWithPopup(auth, provider)
  }

  const value = {
    currentUser,
    // GetUser,
    signInWithGoogle,
    login,
    register,
    logout,
    signInLink,
    sendSignInLink,
    forgotPassword,
    resetPassword,
  }
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}